import { auth } from './firebase';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { db } from './firebase';

const getAdminCredentials = () => {
  const adminEmail = process.env.REACT_APP_ADMIN_EMAIL;
  const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD;
  const editorEmail = process.env.REACT_APP_EDITOR_EMAIL;
  const editorPassword = process.env.REACT_APP_EDITOR_PASSWORD;
  const adminRole = process.env.REACT_APP_ADMIN_ROLE;
  const editorRole = process.env.REACT_APP_EDITOR_ROLE;

  if (!adminEmail || !adminPassword || !editorEmail || !editorPassword || !adminRole || !editorRole) {
    throw new Error('Gerekli çevresel değişkenler eksik');
  }

  return {
    adminEmail,
    adminPassword,
    editorEmail,
    editorPassword,
    adminRole,
    editorRole
  };
};

const setupAdminAndEditor = async () => {
  try {
    const {
      adminEmail,
      adminPassword,
      editorEmail,
      editorPassword,
      adminRole,
      editorRole
    } = getAdminCredentials();

    // Admin hesabını kontrol et veya oluştur
    try {
      await signInWithEmailAndPassword(auth, adminEmail, adminPassword);
    } catch (error) {
      if (error.code === 'auth/user-not-found') {
        const adminUserCredential = await createUserWithEmailAndPassword(auth, adminEmail, adminPassword);
        const adminUser = adminUserCredential.user;
        
        await setDoc(doc(db, 'users', adminUser.uid), {
          email: adminEmail,
          role: adminRole,
          createdAt: new Date()
        });
      }
    }

    // Editor hesabını kontrol et veya oluştur
    try {
      await signInWithEmailAndPassword(auth, editorEmail, editorPassword);
    } catch (error) {
      if (error.code === 'auth/user-not-found') {
        const editorUserCredential = await createUserWithEmailAndPassword(auth, editorEmail, editorPassword);
        const editorUser = editorUserCredential.user;
        
        await setDoc(doc(db, 'users', editorUser.uid), {
          email: editorEmail,
          role: editorRole,
          createdAt: new Date()
        });
      }
    }

    return true;
  } catch (error) {
    console.error('Hesap kurulum hatası:', error);
    throw error;
  }
};

export default setupAdminAndEditor;  